export type ImageSource = number | { uri: string }

/**
 * Devuelve un source seguro para <Image> evitando crasheos en Android cuando
 * uri no es string (p.ej. URL object, null o un mapa anidado).
 * - Acepta: string, number(require), {uri: string}, URL object
 * - Fallback: placeholder (string URL o require)
 */
export const safeImageSource = (src: any, placeholder?: any): ImageSource => {
    try {
        // require() -> number
        if (typeof src === 'number') return src

        // Caso { uri: string }
        if (src && typeof src === 'object' && 'uri' in src) {
            const candidate = (src as any).uri
            if (typeof candidate === 'string' && candidate.trim()) {
                return { uri: candidate.trim() }
            }
            // { uri: URL }
            if (candidate && typeof candidate === 'object' && typeof (candidate as any).href === 'string') {
                return { uri: String(candidate) }
            }
        }

        // URL object (nativo)
        if (src && typeof src === 'object' && typeof (src as any).href === 'string') {
            return { uri: String(src) }
        }

        // string url/file/content
        if (typeof src === 'string' && src.trim()) {
            return { uri: src.trim() }
        }
    } catch {}

    // Fallback a placeholder
    try {
        if (typeof placeholder === 'number') return placeholder
        if (placeholder && typeof placeholder === 'object' && 'uri' in placeholder && typeof placeholder.uri === 'string') {
            return { uri: placeholder.uri }
        }
        if (typeof placeholder === 'string' && placeholder.trim()) {
            return { uri: placeholder.trim() }
        }
    } catch {}

    // Último recurso: devolver un objeto válido mínimo (evitamos undefined)
    return { uri: '' }
}
